import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

// Асинхронный thunk для загрузки карточек
export const fetchCourts = createAsyncThunk(
  'cords/fetchCourts',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const clubId = state.club?.club?.id;

      if (!clubId) return rejectWithValue('Club ID not found');

      const response = await api.get(`/courts/by-club/${clubId}`);

      return response.data; // предполагается, что API возвращает массив карточек
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Ошибка при загрузке карточек'
      );
    }
  }
);

// Начальное состояние
const initialState = {
  cards: [],
  isLoadingCards: false,
  errorCards: null,
};

// Slice
const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    setCards(state, action) {
      state.cards = action.payload;
    },
    addCard(state, action) {
      const newCard = action.payload;
      state.cards.push(newCard);
    },
    editCard(state, action) {
      const { id } = action.payload;
      const index = state.cards.findIndex((card) => card.id === id);
      if (index !== -1) {
        state.cards[index] = {
          ...state.cards[index],
          ...action.payload,
        };
      }
    },
    deleteCard(state, action) {
      state.cards = state.cards.filter((card) => card.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourts.pending, (state) => {
        state.isLoadingCards = true;
        state.errorCards = null;
      })
      .addCase(fetchCourts.fulfilled, (state, action) => {
        state.cards = action.payload;
        state.isLoadingCards = false;
      })
      .addCase(fetchCourts.rejected, (state, action) => {
        state.isLoadingCards = false;
        state.errorCards = action.payload || 'Ошибка при загрузке карточек';
      });
  },
});

export const { setCards, addCard, editCard, deleteCard } = cardsSlice.actions;
export default cardsSlice.reducer;
